<button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon class="close-icon">close</mat-icon>
</button>
<div mat-dialog-title fxLayout="row">
    <div fxLayoutAlign="start">
        Cosa vuoi fare?
    </div>
</div>
<mat-dialog-content></mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-evenly center">
    <div *ngFor="let command of commands">
        <button mat-raised-button [mat-dialog-close]="command.code" [ngClass]="command.colorClass" class="command-button" fxLayout="column" >
            <mat-icon [svgIcon]="command.code?.toLowerCase()" class="command-icon"></mat-icon>
            <div class="command-label">{{ command.statusLabel }}</div>
        </button>
    </div>
</mat-dialog-actions>
